module.exports = __webpack_public_path__ + "static/Chun-092c449b088b6c8aee4bf648f8630be9.jpeg";